import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobs } from "../../features/job/jobSlice";
import JobItem from "./JobItem";

export default function JobList() {
  const { jobs } = useSelector(state => state.job);
  const [data, setData] = useState(jobs || [])
  const { type, sortOrder, queryString } = useSelector(state => state.filter);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchJobs())
  }, [dispatch])

  useEffect(() => {
    if (jobs?.length) {
      const filterdData = jobs.filter(filterByType)
        .filter(filterByQueryStr)
        .sort(sortBySalary(sortOrder));

      setData(filterdData)
    }
  }, [jobs, type, sortOrder, queryString])

  const filterByType = (job) => {
    if (type !== '') {
      return job.type == type;
    }
    return true;
  };

  const filterByQueryStr = (job) => {
    if (queryString != '') {
      const title = job.title.toLowerCase();
      return title.includes(queryString.toLowerCase());
    }
    return true;
  };

  function sortBySalary(order) {
    return function (a, b) {
      const numA = Number(a.salary);
      const numB = Number(b.salary);

      if (Number.isNaN(numA) || Number.isNaN(numB)) {
        return 0; // treat non-numeric values as equal
      }

      if (order === 'desc') {
        return numB - numA; // sort in descending order
      } else if (order === 'asc') {
        return numA - numB; // sort in ascending order
      } else {
        return 0; // default behavior: return the original array without sorting it
      }
    }
  }

  return (
    <div className="jobs-list">
      {
        data?.length ?
          data.map(job => <JobItem job={job} key={job.id} />)
          :
          <div>Jobs Not Found!!</div>
      }
    </div>
  )
}